<!-- Page scrollable content -->
<app-toolbar [team]="team" [isCollapsed]="isCollapsed" [collapseProgress]="collapseProgress" [canFollow]="canFollow"
  [segmentValue]="segmentValue" [innerSegmentValue]="innerSegmentValue" [segmentButtons]="toolbarSegments"
  [innerSegmentButtons]="innerToolbarSegments" (innerSegmentChange)="onInnerSegmentChange($event)"
  (followChange)="changeFollow()" (joinTeam)="onJoinTeam()" [isParticipantLoading]="isPlayerLoading" [isOwner]="isOwner"
  (showTeamPopover)="showTeamPopover($event)" [authService]="authService" (segmentChange)="onSegmentChange($event)"
  [ITAlogo]="ITAlogo" [isUserTeamPlayer]="isUserTeamPlayer">
</app-toolbar>


<ion-content (ionScroll)="onScroll($event)" scrollEvents="true">
  <!-- Your page content here -->

  <div class="content-width">
    <ion-card color="dark" *ngIf="this.isAuthenticationRequired">
      <ion-card-content>
        <ion-item color="dark" lines="none">
          <ion-label class="ion-text-wrap">{{'You are an owner of this team. You must log in to your ITA account to
            update roster and schedule.' | translate}}
          </ion-label>
          <ion-icon slot="start" name="alert-circle" color="warning"></ion-icon>
        </ion-item>
        <ion-button (click)="showItaLoginPopover()" expand="block"> Log in
          {{'with ITA account' | translate}}
        </ion-button>
        <ion-item color="dark">
          <ion-label class="ion-text-wrap">{{'Are you not associated with this team anymore?' | translate}}
          </ion-label>
          <ion-button slot="end" color="danger" (click)="removeAdminOwner()" fill="clear"> {{'Leave team' | translate}}
          </ion-button>
          @if (authService.authUserSignal()?.role?.value === 500) {
          <ion-button color="light" slot="end" (click)="verifyTeam()" fill="clear"> {{'Verify' | translate}}
          </ion-button>
          }
        </ion-item>
      </ion-card-content>
    </ion-card>
  </div>


  <!-- <ng-container *ngIf="enableAddPlayerBtn && innerSegmentValue === 'players' && segmentValue === 'players'">
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="isOwner">
      <ion-fab-button (click)="addPlayer()">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container> -->
  <ng-container *ngIf="enableAddPlayerBtn && innerSegmentValue === 'coaches' && segmentValue === 'players'">
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="isOwner">
      <ion-fab-button (click)="addCoach()">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container>
  <ng-container *ngIf="innerSegmentValue === 'staff' && segmentValue === 'players'">
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="isOwner">
      <ion-fab-button (click)="addOwner()">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container>

  <ng-container *ngIf="enableAddPlayerBtn && innerSegmentValue === 'players' && segmentValue === 'players'">
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="isOwner">
      <ion-fab-button (click)="openInviteSheet()">
        <ion-icon name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container>


  <!-- *ngIf="
        team?._id &&
        (!team?.organisations?.length || SeasonSelectorComponent?.seasons?.length)
      " 
  condition is removed for reference IOCINIT-116 | comment if user is owner of that team and team is not ITA or USTA but it has the organisation or not
      -->
  <router-outlet></router-outlet>
  <ng-container *ngIf="innerSegmentValue === 'players' && segmentValue === 'players' && !isPlayerLoading">
    <div class="ion-padding content-width add-player-button-main">
      <ion-button *ngIf="!showIsPlayer && !isOwner" class="add-player-button" (click)="displayJoinAsPlayer()"
        expand="block">
        <ion-icon slot="start" name="add"></ion-icon>
        I'm a player
      </ion-button>
    </div>
  </ng-container>

  <ng-container *ngIf="innerSegmentValue === 'fans' && canFollow && !isOwner">
    <div class="ion-padding content-width add-player-button-main">
      <ion-button *ngIf="canFollow && !isOwner" class="add-player-button" (click)="changeFollow()"
        expand="block">
        <ion-icon slot="start" name="add"></ion-icon>
        I'm a fan
      </ion-button>
    </div>
  </ng-container>
</ion-content>